import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var WifiOff = function WifiOff(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M15.3119 10a11 11 0 0 1 3.7681 2.05m3.4999-3.55a16 16 0 0 0-12.3827-3.8955M8.5298 15.61a6 6 0 0 1 6.95 0M12 19.5h.01M1.1934 8.7008A16.01 16.01 0 0 1 5.7585 5.763m-1.0265 6.48c1.3974-1.231 3.1098-2.1128 5.0007-2.509m5.9657 6.0411A5.974 5.974 0 0 0 11.9999 14.5a5.975 5.975 0 0 0-3.7445 1.3116M3 3l18 18"
    })
  }));
};
export default WifiOff;